import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL } from '@core/injectors';
import { SsoSnowflakeDTO } from '@core/models';
import { Observable } from 'rxjs';

@Injectable()
export class SnowflakeSsoService {
  constructor(
    private readonly http: HttpClient,
    @Inject(API_BASE_URL) private readonly apyBaseUrl: string,
  ) {}

  snowflakeSSO(url: string): Observable<SsoSnowflakeDTO> {
    return this.http.get<SsoSnowflakeDTO>(`${this.apyBaseUrl}/api/snowflake/sso/init/?sp=${url}`);
  }
}
